import { book } from "@circleofa/acim-book/dist/book"
import { GlobalSettings, generateACIM } from "@circleofa/acim-engine"

GlobalSettings.cacheWords = false
GlobalSettings.precacheWords = false

export const acim = generateACIM(book)

// @ts-expect-error acim
globalThis.acim = acim
